import React, { useEffect, useMemo, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Remove } from '@material-ui/icons';
import { shallowEqual, useSelector } from 'react-redux';

import { cancel } from '../../../../airtable/generic';
import { fetchDCISubmissions, fetchRecords } from '../../../../airtable/grading';
import { dciGradingFields, dciSubmissionsFields } from '../../../../airtable/metadata/grading';
import { createColumn, DynamicTable } from '../../../components/dynamic-table';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  toolbar: {
    display: 'flex',
    minHeight: '64px',
    padding: '16px',
  },
}));

export function GradingDCITable(props) {
  const { base, commonColumns } = props;

  const classes = useStyles();
  const user = useSelector(({ auth }) => auth.user, shallowEqual);

  // const [applying, setApplying] = useState(false);
  // const [hasModifiedActions, setHasModifiedActions] = useState(false);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState();

  const columns = useMemo(() => {
    return [
      ...commonColumns.map(column => {
        return { ...column, editable: 'never' };
      }),
      createColumn(dciGradingFields.DCI_GRADE, {
        editable: 'never',
        type: 'numeric',
      }),

      // createColumn(dciGradingFields.DCI_ACTION, {
      //   editable: 'onUpdate',
      //   lookup: {
      //     [dciGradingActions.SEND_TO_GRADING]: dciGradingActions.SEND_TO_GRADING,
      //     // [dciGradingActions.SEND_TO_CONSIGNMENT]: dciGradingActions.SEND_TO_CONSIGNMENT,
      //     [dciGradingActions.SEND_HOME]: dciGradingActions.SEND_HOME,
      //   },
      //   render: (rowData = {}) => {
      //     if (notGradedYet(rowData)) {
      //       return 'Not graded yet';
      //     }
      //     return rowData[dciGradingFields.DCI_ACTION];
      //   },
      // }),
      //
      // createColumn(dciGradingFields.DESTINATION, {
      //   invalidTest: (value, row) => {
      //     return (typeof value !== 'string' || value.length <= 0)
      //       && sendToGrading(row);
      //   },
      //   invalidText: 'is required',
      //   lookup: destinations,
      //   render: (rowData = {}) => {
      //     const value = rowData[dciGradingFields.DESTINATION];
      //
      //     if (value) {
      //       return value;
      //     }
      //
      //     return <Remove />;
      //   },
      //   editComponent: props => {
      //     const { columnDef, onChange, rowData = {}, value } = props;
      //
      //     if (!sendToGrading(rowData)) {
      //       if (value !== columnDef.initialEditValue) {
      //         onChange(columnDef.initialEditValue);
      //       }
      //       return <Remove />;
      //     }
      //
      //     return editComponentDefault(props);
      //   },
      // }),
      //
      // createColumn(dciGradingFields.SERVICE_LEVEL, {
      //   invalidTest: (value, row) => {
      //     return (typeof value !== 'string' || value.length <= 0)
      //       && sendToGrading(row);
      //   },
      //   invalidText: 'is required',
      //   lookup: serviceLevels,
      //   render: rowData => {
      //     return renderValueOrRemoveIcon(rowData, dciGradingFields.SERVICE_LEVEL);
      //   },
      //   editComponent: props => {
      //     const { columnDef, onChange, rowData = {}, value } = props;
      //
      //     if (!sendToGrading(rowData)) {
      //       if (value !== columnDef.initialEditValue) {
      //         onChange(columnDef.initialEditValue);
      //       }
      //       return <Remove />;
      //     }
      //
      //     return editLookupBasedOnParentLookup(props, dciGradingFields.DESTINATION);
      //   },
      // }),
      //
      // createColumn(dciGradingFields.DECLARED_VALUE, {
      //   currencySetting: {
      //     maximumFractionDigits: 0,
      //     minimumFractionDigits: 0,
      //   },
      //   initialEditValue: 0,
      //   invalidTest: value => typeof value !== 'number' || value < 0,
      //   invalidText: 'cannot be negative',
      //   type: 'currency',
      //   editComponent: props => {
      //     const { columnDef, onChange, rowData = {}, value } = props;
      //
      //     if (!sendToGrading(rowData)) {
      //       if (value !== columnDef.initialEditValue) {
      //         onChange(columnDef.initialEditValue);
      //       }
      //       return <Remove />;
      //     }
      //
      //     const customOnChange = value => {
      //       onChange(value > 0 ? Math.trunc(value) : 0);
      //     };
      //
      //     return editComponentDefault({ ...props, onChange: customOnChange });
      //   },
      // }),

      createColumn(dciGradingFields.DECLARED_VALUE, {
        currencySetting: {
          maximumFractionDigits: 0,
          minimumFractionDigits: 0,
        },
        editable: 'never',
        initialEditValue: 0,
        invalidTest: value => typeof value !== 'number' || value < 0,
        invalidText: 'cannot be negative',
        type: 'currency',
      }),

      createColumn(dciSubmissionsFields.RETURN_TRACKING_NUMBER, {
        editable: 'never',
        type: 'string',
        render: rowData => {
          const value = rowData[dciSubmissionsFields.RETURN_TRACKING_NUMBER];

          if (value) {
            return value;
          }
          return <Remove />;
        },
      }),

    ];
  }, [commonColumns]);

  useEffect(() => {
    // setHasModifiedActions(false);
    setRefresh(false);
    setLoading(true);
    setStatus();

    const promise = fetchRecords(base, user)
      .then(async records => {
        const ids = new Set(records.map(record => record.fields[dciGradingFields.SUBMISSION_NUMBER]));
        const submissions = await fetchDCISubmissions(base, Array.from(ids));
        const tracking = {};

        for (const submission of submissions) {
          const key = submission.fields[dciSubmissionsFields.SUBMISSION_NUMBER];
          tracking[key] = submission.fields[dciSubmissionsFields.RETURN_TRACKING_NUMBER];
        }

        const fetchedRows = records.map(record => {
          return {
            ...record.fields,
            [dciSubmissionsFields.RETURN_TRACKING_NUMBER]: tracking[record.fields[dciGradingFields.SUBMISSION_NUMBER]],
            hadActionAlready: !!record.fields[dciGradingFields.DCI_ACTION],
            id: record.id,
          };
        });

        setRows(fetchedRows);
      })
      .catch(error => {
        setStatus({ error: true, text: error.message });
      })
      .finally(() => {
        setLoading(false);
      });

    return () => cancel(promise);
  }, [base, refresh, user]);

  // const onRowsChanged = rows => {
  //   setRows(rows);
  //
  //   for (const row of rows) {
  //     if (hasModifiedAction(row)) {
  //       setHasModifiedActions(true);
  //       return;
  //     }
  //   }
  // };
  //
  // const apply = () => {
  //   setApplying(true);
  //   setStatus();
  //
  //   const modifiedRows = [];
  //
  //   for (const row of rows) {
  //     if (hasModifiedAction(row)) {
  //       modifiedRows.push(row);
  //     }
  //   }
  //
  //   updateDCIAction(base, modifiedRows)
  //     .then(() => {
  //       setStatus({ error: false, text: 'Actions submitted successfully.' });
  //       setRefresh(true);
  //     })
  //     .catch(error => {
  //       setStatus({ error: true, text: error.message });
  //     })
  //     .finally(() => {
  //       setApplying(false);
  //     });
  // };

  return (
    <div className={classes.root}>
      {status && (
        <div className={`alert alert-custom alert-dismissible alert-light-${status.error ? 'danger' : 'success'}`}>
          <div className="alert-text font-weight-bold">
            {status.text}
          </div>
        </div>
      )}

      <DynamicTable
        columns={columns}
        // editable={{
        //   isEditHidden: row => notGradedYet(row) || row.hadActionAlready,
        // }}
        editable={false}
        editableOptions={{
          add: false,
          bulk: false,
          delete: false,
          duplicate: false,
          single: true,
        }}
        loading={loading}
        // onRowsChanged={onRowsChanged}
        options={{
          padding: 'dense',
        }}
        replaceComponents={{
          // Toolbar: () => (
          //   <div className={`MuiToolbar-root MuiToolbar-regular ${classes.toolbar}`}>
          //     <div style={{ flex: '1 1 10%' }} />
          //     <Button
          //       disabled={applying || loading || !hasModifiedActions}
          //       onClick={apply}
          //       type="submit"
          //       variant="primary"
          //       style={{ width: '260px' }}
          //     >
          //       <span>Apply actions selected below</span>
          //       {applying && <span className="ml-3 spinner spinner-white" />}
          //     </Button>
          //   </div>
          // ),
          Toolbar: () => <div />,
        }}
        rows={rows}
        title={base}
      />
    </div>
  );
}

// function hasModifiedAction(row = {}) {
//   return row[dciGradingFields.DCI_ACTION] && !row.hadActionAlready;
// }
//
// function notGradedYet(row = {}) {
//   return typeof row[dciGradingFields.DCI_GRADE] !== 'number';
// }
//
// function sendToGrading(row = {}) {
//   return row[dciGradingFields.DCI_ACTION] === dciGradingActions.SEND_TO_GRADING;
// }
